module.exports = __webpack_public_path__ + "static/img/1.4e63707.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/1.png
// module id = bdaU
// module chunks = 0